import React from "react";

import { customIcon } from "./custom-icon";

const playIconPath = () => (
  <path d="M16 10c0-.36-.2-.67-.49-.84l.01-.01-10-6-.01.01A.991.991 0 005 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .19 0 .36-.07.51-.16l.01.01 10-6-.01-.01c.29-.17.49-.48.49-.84z" />
);

export const playIcon = customIcon({ path: playIconPath() });
